module.exports = __webpack_public_path__ + "static/media/lightbulb_3.f9057d77.png";